import React, { useState,useEffect } from 'react';

import plusIcon from "../../../img/icon/icon-plus.svg";
import minusIcon from "../../../img/icon/icon-minus.svg";

const TextBooks = ({ varIndex,varMode,setMode,varBookList,varBookOrders,setBookOrders,onMangementBookHandler }) => {

  const [varTitleList,setTitleList] = useState([]);
  const [varBookData,setBookData] = useState({});
  const [varBookMode,setBookMode] = useState(0);

  //최초실행부
  useEffect(() => {
    const bookInfo = varBookOrders.find(el=>el.tbl_idx===varIndex);
    bookInfo.vb_idx = varMode;
    setBookMode(varMode);
    setBookData(bookInfo);
    //단계
    const titleList = varBookList.filter(el=>el.vb_vt_mode===varMode);
    setTitleList(titleList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varIndex]);

  useEffect(() => {
    //교재정보읽기
    if(varBookData.vb_idx > 0) {
      console.log(varBookMode,varBookData);
      const selectBookInfo = varBookList.find(el=>el.vb_idx===varBookData.vb_idx);
      //교재 가격
      let vb_price = selectBookInfo.vb_price;

      //교재정보 ->구매정보로 저장
      const copyList = [...varBookOrders];
      const findIndex = copyList.findIndex(el=>el.tbl_idx === varIndex);
      copyList[findIndex].vb_idx = varBookData.vb_idx;
      copyList[findIndex].tbl_price = vb_price;
      copyList[findIndex].tbl_number = varBookData.tbl_number;
      setBookOrders(copyList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varBookData]);
  
  //과목선택시
  const onSelectBookModeHandler = (e) => {
    const vb_vt_mode = Number(e.currentTarget.value);
    setBookMode(vb_vt_mode);
    setMode(vb_vt_mode);
    const titleList = varBookList.filter(el=>el.vb_vt_mode===vb_vt_mode);
    setTitleList(titleList);
    setBookData({...varBookData,vb_idx:0});
  }
  //단계선택시
  const onSelectBookTitleHandler = (e) => {
    const vb_idx = Number(e.currentTarget.value);
    setBookData({...varBookData,vb_idx:vb_idx});
  }
  //수량
  const onSelectBookNumberHandler = (e) => {
    const tbl_number = Number(e.currentTarget.value);
    const bookData = varBookList.find(el=>el.vb_idx===varBookData.vb_idx);
    setBookData({...varBookData,tbl_number:tbl_number,tbl_price:bookData.vb_price});
  }
  //console.log(varBookData);
  return (
    <div className="tb-line">
      <select name="vb_vt_mode" value={varBookMode} onChange={e=>onSelectBookModeHandler(e)}>
        <option value={0}>과목선택</option>
        <option value={1}>수/연산</option>
        <option value={2}>감각/기하</option>
      </select>
      <select name="vb_idx" value={varBookData.vb_idx} onChange={e=>onSelectBookTitleHandler(e)}>
        <option value={0}>단계선택</option>
        {varTitleList.map((titles,i)=>(
          <option key={'titles_'+i} value={titles.vb_idx}>{titles.vb_vt_name}</option>
        ))}
      </select>
      <input type="number" name="tbl_number" value={varBookData.tbl_number||""} onChange={e=>onSelectBookNumberHandler(e)}/>
      <button onClick={e=>onMangementBookHandler(e,varBookData.tbl_idx)}><img src={varBookData.tbl_idx===0?plusIcon:minusIcon} alt=""/></button>
    </div>
  )
}
export default TextBooks;